import { render, staticRenderFns } from "./OriginPopUp.vue?vue&type=template&id=6df5cacb"
import script from "./OriginPopUp.vue?vue&type=script&lang=js"
export * from "./OriginPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports